import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import ParamForm from './ParamForm';
const useStyles = makeStyles(theme => ({
  sectionOutline: {
    width: '100%',
    border: '1px solid #aaffaa',
    background: '#eaeaea',
    padding: '10px 20px',
    margin: '0 auto',
    marginTop: '10px',
  },
}));

export default function SubgroupSection({
  moduleName,
  groupName,
  subgroup,
  updateParam,
}) {
  const classes = useStyles();
  return (
    <section className={classes.sectionOutline}>
      {subgroup.params.map((param, index, array) => {
        return <ParamForm key={index} item={param} updateParam={updateParam} />;
      })}
    </section>
  );
}
